import type { Identity } from '@seek/online-identity/lib-types/types';

class MockAuthService {
  async getToken() {
    return 'mockSsoToken';
  }

  getIdentity(): Promise<Identity> {
    return Promise.resolve({
      sub: {
        ID: 'mockIdentity',
        email: 'mockEmail',
      },
    });
  }

  async loginWithRedirect() {
    return Promise.resolve({});
  }
}

export default new MockAuthService();
